import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from '@mui/icons-material/Send';
import Snackbar from '@mui/material/Snackbar';
import { Box, Button, Alert } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { deleteData } from "../func/api";
import DeleteIcon from "@mui/icons-material/Delete";

import { useAuth } from "../contexts/AuthContext";
import { BaseDialog } from "./base_dialog";

export default function DeleteEarthquakeDialog({ earthquake, onDeleted }) {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [deleteMessage, setDeleteMessage] = useState("");
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");


    const handleClickOpen = () => {
        setOpen(true);
        setErrorMessage("");
    };

    const handleClose = () => {
        setOpen(false);
    };

    // 削除処理
    const handleDelete = async () => {
        try {
            const response = await deleteData(`/api/delete_earthquakes_with_report/${earthquake.uuid}`);
            setDeleteMessage("地震データを削除しました。");
            setAlertSeverity("success")
            setAlertOpen(true)
            setOpen(false);
            if (onDeleted) onDeleted();
        } catch (error) {
            console.error("削除に失敗しました:", error);
            setDeleteMessage("削除に失敗しました。もう一度お試しください。");
            setAlertSeverity("error")
            setAlertOpen(true)
        }
    };

    return (
        <>
            <IconButton onClick={handleClickOpen}>
                <DeleteIcon />
            </IconButton>
            <BaseDialog
                open={open}
                onClose={handleClose}
                title="地震削除"
                message={"該当の地震データおよび関連の報告書データを削除します。\nよろしいですか？"}
                onConfirm={handleDelete}
                confirmText='削除'
                cancelText='キャンセル'
            />
            {deleteMessage && (
                <Snackbar
                    open={alertOpen}
                    autoHideDuration={3000}
                    onClose={() => setAlertOpen(false)}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }} // 右上に表示
                >
                    <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
                        {deleteMessage}
                    </Alert>
                </Snackbar>
            )}
        </>
    );
}
